import api from '@/api/api';
import {SalesContact} from '@/models/dealers';
import {AxiosResponse} from 'axios';


export default {
    search: (): Promise<AxiosResponse<SalesContact>> => {
        return api.get('sales-contacts/v1/');
    },
    performSearchWithFilters: (country: string | null, productLine: string | null): Promise<AxiosResponse<SalesContact>> => {
        return api.get('sales-contacts/v1/', {
            params: {
                country,
                productLine
            }
        });
    }
};
